/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TransactionDto } from "./TransactionDto";
import {
    TransactionDtoFromJSON,
    TransactionDtoFromJSONTyped,
    TransactionDtoToJSON,
} from "./TransactionDto";

/**
 *
 * @export
 * @interface DeviceConnectorTransactionsResponse
 */
export interface DeviceConnectorTransactionsResponse {
    /**
     *
     * @type {Array<TransactionDto>}
     * @memberof DeviceConnectorTransactionsResponse
     */
    transactions?: Array<TransactionDto>;
    /**
     *
     * @type {string}
     * @memberof DeviceConnectorTransactionsResponse
     */
    nextCursor?: string;
}

/**
 * Check if a given object implements the DeviceConnectorTransactionsResponse interface.
 */
export function instanceOfDeviceConnectorTransactionsResponse(
    value: object,
): value is DeviceConnectorTransactionsResponse {
    return true;
}

export function DeviceConnectorTransactionsResponseFromJSON(
    json: any,
): DeviceConnectorTransactionsResponse {
    return DeviceConnectorTransactionsResponseFromJSONTyped(json, false);
}

export function DeviceConnectorTransactionsResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConnectorTransactionsResponse {
    if (json == null) {
        return json;
    }
    return {
        transactions:
            json["transactions"] == null
                ? undefined
                : (json["transactions"] as Array<any>).map(
                      TransactionDtoFromJSON,
                  ),
        nextCursor: json["nextCursor"] == null ? undefined : json["nextCursor"],
    };
}

export function DeviceConnectorTransactionsResponseToJSON(
    value?: DeviceConnectorTransactionsResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        transactions:
            value["transactions"] == null
                ? undefined
                : (value["transactions"] as Array<any>).map(
                      TransactionDtoToJSON,
                  ),
        nextCursor: value["nextCursor"],
    };
}
